import React, { ReactNode, useEffect, useState } from 'react';
import styles from '../styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import { Car } from '@/commonTypes';
import Select from '@/components/common/Select';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';

// const PLATE_LETTERS = ['الف', 'ب', 'ج', 'د', 'س', 'ص', 'ط', 'ق', 'ل', 'م', 'ن', 'و', 'ه', 'ی'];
const PLATE_LETTERS = [
  { id: '01', title: 'الف' },
  { id: '02', title: 'ب' },
  { id: '03', title: 'ت' },
  { id: '04', title: 'ج' },
  { id: '05', title: 'د' },
  { id: '06', title: 'س' },
  { id: '07', title: 'ص' },
  { id: '08', title: 'ط' },
  { id: '09', title: 'ع' },
  { id: '10', title: 'ق' },
  { id: '11', title: 'ل' },
  { id: '12', title: 'م' },
  { id: '13', title: 'ن' },
  { id: '14', title: 'و' },
  { id: '15', title: 'ه' },
  { id: '16', title: 'ی' },
  { id: '17', title: 'ر' },
  { id: '18', title: 'ک' },
  { id: '19', title: 'ژ' },
  { id: '20', title: 'ف' },
];
export default function PlateInput({
  title,
  titleIcon,
  callBackInputChange,
  disabled = false,
  inputClass = '',
  size = 'lg',
  noMaxWidth = false,
}: {
  title?: string;
  titleIcon?: ReactNode;
  callBackInputChange?: (x?: Car) => void;
  disabled?: boolean;
  inputClass?: string;
  size?: 'sm' | 'lg';
  noMaxWidth?: boolean;
}) {
  const { activeCar, setActiveCar } = useLayoutContext();
  const hero = {
    plateHint: '',
    region: 'iran',
  };
  const [plateField, setPlateField] = useState<Car>({ plate: { a: '', b: '', c: '', r: '' } });
  const onChange = (name: string, value: string | number) => {
    const newfields = { ...plateField, plate: { ...plateField?.plate, [name]: value } };
    setPlateField(newfields);
    callBackInputChange && callBackInputChange(newfields);
  };
  useEffect(() => {
    if (activeCar) {
      setPlateField(activeCar);
    }
    //  else {
    //   setPlateField({ plate: TransformPlateNumber('ایران ۸۸ - 888 ج ۸8') });
    // }
  }, [activeCar]);
  console.log('activeCar==', activeCar, plateField?.plate);
  return (
    <>
      {title && (
        <div className={styles.head}>
          {titleIcon}
          <span className={styles.hint}>{title}</span>
        </div>
      )}
      <div
        dir="ltr"
        className={`${styles.row} ${noMaxWidth && styles.noMaxWidth} ${inputClass} ${size == 'sm' && styles.smallInput}`}
      >
        <div className={styles.region}>
          <div className={styles.flag}>
            <div className={styles.flagGreen} />
            <div className={styles.flagWhite} />
            <div className={styles.flagRed} />
          </div>
          <span className={styles.flagLabel}>I.R.IRAN </span>
        </div>

        <input
          className={styles.num}
          value={plateField?.plate?.a}
          onChange={(e) => onChange('a', e.target.value)}
          maxLength={2}
          placeholder="۱۲"
          disabled={disabled}
        />

        <Select
          wrapperClassname={`${styles.selectWrap}`}
          className={styles.select}
          placeholder="-"
          list={PLATE_LETTERS}
          insideWrapperClass={`${styles.insideWrapperClass}`}
          buttonContainerStyle={`${styles.selectButton}`}
          boxClass={`${styles.selectBox}`}
          extraActiveStyle={`${styles.activeStyleSelect}`}
          value={
            activeCar?.plate
              ? PLATE_LETTERS?.filter((x) => x?.title == plateField?.plate?.b)?.[0]?.id
              : ''
          }
          fillFormFunction={(id) => {
            // onChange('b', PLATE_LETTERS?.filter((x) => x?.id == id)?.[0]?.title,);
            const newfields = {
              ...plateField,
              plate: {
                ...plateField?.plate,
                b: PLATE_LETTERS?.filter((x) => x?.id == id)?.[0]?.title,
                code: id,
              },
            };
            setPlateField(newfields);
            callBackInputChange && callBackInputChange(newfields);
          }}
          disabled={disabled}
        />
        <input
          className={styles.num}
          value={plateField?.plate?.c}
          onChange={(e) => onChange('c', e.target.value)}
          maxLength={3}
          placeholder="۳۴۵"
          disabled={disabled}
        />

        <div className={styles.regionRight}>
          <input
            className={styles.regionInput}
            value={plateField?.plate?.r}
            onChange={(e) => onChange('r', e.target.value)}
            maxLength={2}
            placeholder="۶۷"
            disabled={disabled}
          />
          <span className={styles.regionLabel}>{hero.region}</span>
        </div>
      </div>
    </>
  );
}
